import { render, staticRenderFns } from "./AddInventory.vue?vue&type=template&id=0b899354&"
import script from "./AddInventory.vue?vue&type=script&lang=js&"
export * from "./AddInventory.vue?vue&type=script&lang=js&"
import style0 from "./AddInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/AddInventory.vue
// module id = null
// module chunks = 